import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-[#0B0B1A] py-16 md:py-24 px-4 text-white relative overflow-hidden" data-id="element-168">
      {/* Background glow effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#00D4FF] opacity-10 blur-[120px] rounded-full pointer-events-none" data-id="element-169" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-170">
        <div className="text-center mb-12" data-id="element-171">
          <span className="inline-block bg-[#00FF66]/20 text-[#00FF66] px-6 py-2 rounded-full font-bold text-xl mb-6 border border-[#00FF66]/30" data-id="element-172">
            ✅ La solución
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold mb-6" data-id="element-173">
            Colección Ciberseguridad para Personas Comunes
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto" data-id="element-174">
            Un sistema práctico que te enseña cómo protegerte en internet,
            aunque no tengas conocimientos técnicos.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-175">
          <p className="text-2xl font-bold text-center mb-8 text-[#00D4FF]" data-id="element-176">
            Cuando aplicas estas reglas puedes:
          </p>

          <ul className="space-y-6 max-w-2xl mx-auto" data-id="element-177">
            {['proteger tus cuentas', 'evitar estafas digitales', 'detectar intentos de hackeo', 'recuperar cuentas robadas', 'proteger tu negocio online'].map((item, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-4 text-xl md:text-2xl font-medium" data-id="element-178">
                <CheckCircle2 className="w-8 h-8 text-[#00FF66] flex-shrink-0" data-id="element-179" />
                <span data-id="element-180">{item}</span>
              </motion.li>)}
          </ul>

          <div className="mt-12 text-center" data-id="element-181">
            <p className="text-2xl md:text-3xl font-bold text-[#FF00FF]" data-id="element-182">
              Todo explicado de forma simple y práctica.
            </p>
          </div>
        </div>
      </div>
    </section>;
}